<template>
  <div id="app">
    <!-- <div class="shadeBox"></div> -->
    <div class="homebox">
      <div class="public">
        <div class="homenav">
          <div class="lt">
            <img src="./image/logo-lv.png" alt="" class="logo" />
            <p>无人机数字化智慧工场</p>
          </div>
          <Navmenu @login="login" @regest="regest" />
        </div>
      </div>
      <div class="toolbox" @click="backtop">
        <div class="pozhe"></div>
        <div class="tooltop">回到顶部</div>
      </div>
      <!-- <Tool time="200" v-if="$store.state.path == '/homePage'"></Tool> -->
    </div>

    <router-view class="baseview" />

    <Bottom></Bottom>
    <!-- :Visible="Visible"  -->
    <RegestLogin
     
      :regest_flag="regest_flag"
      :login_flag="login_flag"
      @handleClose="handleClose"
      v-if="Visible"
    ></RegestLogin>
  
  </div>
</template>
<script>
import Navmenu from "./components/navmenu.vue";
import RegestLogin from "./components/regest_login.vue";
import Bottom from "./components/bottom.vue";
export default {
  components: {
    Bottom,
    Navmenu,
    RegestLogin,
  },
  data() {
    return {
      Visible: false,
      login_flag: false,
      regest_flag: false,
    };
  },

  created() {
    // console.log(this.$route);
    //在页面加载时读取sessionStorage里的状态信息
    if (sessionStorage.getItem("store")) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem("store"))
        )
      );
    }

    //在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("store", JSON.stringify(this.$store.state));
    });
  },
  watch: {
    $route(to) {
      this.$store.commit("CHANGE_PAGE", to.path);
      // console.log(to);

      document.title = `${to.meta.text} `;
      // chrome
      document.body.scrollTop = 0;
      // firefox
      document.documentElement.scrollTop = 0;
      // safari
      window.pageYOffset = 0;
    },
  },

  methods: {
    backtop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    handleClose() {
      this.Visible = false;
      this.regest_flag=false;
      this.login_flag=false;
    },

    login() {
      this.regest_flag = false;
      this.login_flag = true;
      this.Visible = true;
      
    },
    regest() {
      this.login_flag = false;
      this.regest_flag = true;
      this.Visible = true;
     
    },
   

  },
  mounted() {
    // window.addEventListener("popstate", this.cancel, false);
    // 在ie浏览器，浏览器前进后退按钮 改变导航栏样式（谷歌浏览器正常）
    if (window.ActiveXObject || "ActiveXObject" in window) {
      window.addEventListener(
        "hashchange",
        () => {
          let currentPath = window.location.hash.slice(1);
          if (this.$route.path == currentPath) {
            this.$store.commit("CHANGE_PAGE", currentPath);
          }
        },
        false
      );
    }
  },
};
</script>
<style>
* {
  margin: 0px;
  padding: 0px;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  position: relative;
  min-width: 1330px;
}
.el-pager .active {
  width: 35px !important;
  height: 34px !important;
  background: #1e7bc9 !important;
  border-radius: 2px;
}
.el-pager li {
  width: 35px;
  height: 34px;
  background: #ffffff !important;
  padding: 2px 4px !important;
}
.el-pager .number {
  width: 35px;
  height: 34px;
}
.btn-prev,
.btn-next {
  width: 70px !important;
  height: 34px !important;
  background: #ffffff !important;
  border-radius: 2px;
}
.el-pagination {
  text-align: center;
  margin-top: 40px;
  padding-bottom: 40px;
}
.new-infor {
  width: 100%;
  background: #f5f7fa;
  padding-bottom: 49px;
}
/* flex布局 */
.group {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  flex-direction: row;
}
.banner {
  background-size: 100% 100%;
  background-size: cover;
  min-width: 1200px;
  height: 420px;
}
ul li {
  list-style: none;
}
.localbk {
  min-width: 1200px;
  background: #f5f7fa;
}
.baseview {
  min-height: 900px;
}
.local {
  display: flex;
  align-items: center;
  justify-items: center;
  width: 1200px;
  margin: 0 auto;
  height: 48px;
  flex-wrap: nowrap;
  white-space: nowrap;
}
.local .elitem {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 600;
  color: #999999;
  line-height: 20px;
  cursor: pointer;
  margin: 0 4px;
}
.el-breadcrumb {
  display: flex;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.entreqtl {
  font-size: 30px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  margin-bottom: 24px;
  margin-top: 20px;
  text-align: center;
}
.entreqtm {
  text-align: center;
  height: 12px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  line-height: 24px;
  margin-bottom: 60px;
}

.el-loading-spinner {
  font-size: 80px;
  font-weight: bold;
}

.el-loading-mask .el-loading-spinner .el-loading-text {
  font-size: 18px;
}
.reqcontent {
  width: 1200px;
  margin: 0 auto;
  padding-top: 40px;
  padding-bottom: 40px;
  margin-bottom: 60px;
}
.el-breadcrumb {
  height: 22.9987px;
  font-size: 13.9988px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999 !important;
  line-height: 19.0013px;
  line-height: 48px !important;
  height: 48px !important;
}
.el-breadcrumb__inner.is-link {
  color: #999999 !important;
}
.el-breadcrumb__inner {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #999999 !important;
}
.el-input__inner,
.el-input,
.el-form-item__content {
  width: 300px !important;
}

.freenav {
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: #999999;
  cursor: pointer;
}
.xiegang {
  margin: 0 10px;
}
.breadcrumb {
  width: 800px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>

<style  scoped>
.toolbox {
  position: fixed;
  bottom: 10%;
  right: 20px;
  width: 62px;
  height: 62px;
  background: #ffffff;
  box-shadow: 0px 0px 6px 0px rgba(7, 36, 48, 0.14);
  z-index: 999;
  background: #ffffff;
  font-size: 12px;
  color: #7777;
  cursor: pointer;
  border-radius: 8px;
  text-align: center;
}

.pozhe {
  width: 42px;
  margin: 0 auto;
  height: 32px;
  background-position: 20px 20px;
  background: url("./image/toolbar(1).png");
}
.toolbox:hover {
  color: #047ac6;
}
.toolbox:hover .pozhe {
  background-position: 0px 36px;
}
.homebox {
  position: relative;
}

.homenav {
  width: 1200px;
  margin: 0 auto;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  /* justify-content: center; */
  flex-wrap: nowrap;
  white-space: nowrap;
}

.lt {
  /* width: 200px; */
  display: flex;
  align-items: center;
}
.lt p {
  color: #047ac6;
  font-weight: 600;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #047ac6;
  line-height: 19px;
}
.logo {
  width: 43px;
  margin-right: 12px;
}

body {
  user-select: none;
}
</style>